export const xsmall = 375;
export const small = 576;
export const medium = 768;
export const large = 992;
export const huge = 1200;

export const mediaDesktop = `@media (min-width: ${small}px)`;
export const mediaTabletAndLarger = `@media (min-width: ${medium}px)`;
export const mediaLargeAndLarger = `@media (min-width: ${large}px)`;
export const mediaHugeAndLarger = `@media (min-width: ${huge}px)`;

export const mediaMaxWidthXXSmall = `@media (max-width: ${xsmall - 1}px)`;
export const mediaMaxWidthXSmall = `@media (max-width: ${small - 1}px)`;
export const mediaMaxWidthSmall = `@media (max-width: ${medium - 1}px)`;
export const mediaMaxWidthMedium = `@media (max-width: ${large - 1}px)`;
export const mediaMaxWidthLarge = `@media (max-width: ${huge - 1}px)`;

export const containerWidthTabletAndLarger = 750;
export const containerWidthLargeAndLarger = 970;
export const containerWidthHugeAndLarger = 1170;
